"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWorkStatusSort = exports.UserWorkStatus = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["USER"] = "default";
    UserRole["GUEST"] = "guest";
    UserRole["ADMIN"] = "admin";
    UserRole["ANALYST"] = "analyst";
    UserRole["DEVICE"] = "device";
    UserRole["DEVICE_MANAGER"] = "device_manager";
    UserRole["INSTANCE_ADMIN"] = "superadmin";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var UserWorkStatus;
(function (UserWorkStatus) {
    UserWorkStatus["FromHome"] = "FromHome";
    UserWorkStatus["FromOffice"] = "FromOffice";
    UserWorkStatus["WorkingRemotely"] = "WorkingRemotely";
    UserWorkStatus["OnVacation"] = "OnVacation";
    UserWorkStatus["Unavailable"] = "Unavailable";
})(UserWorkStatus = exports.UserWorkStatus || (exports.UserWorkStatus = {}));
var UserWorkStatusSort;
(function (UserWorkStatusSort) {
    UserWorkStatusSort[UserWorkStatusSort["FromOffice"] = 1] = "FromOffice";
    UserWorkStatusSort[UserWorkStatusSort["FromHome"] = 2] = "FromHome";
    UserWorkStatusSort[UserWorkStatusSort["WorkingRemotely"] = 3] = "WorkingRemotely";
    UserWorkStatusSort[UserWorkStatusSort["OnVacation"] = 4] = "OnVacation";
    UserWorkStatusSort[UserWorkStatusSort["Unavailable"] = 5] = "Unavailable";
})(UserWorkStatusSort = exports.UserWorkStatusSort || (exports.UserWorkStatusSort = {}));
